import { Component } from '@theme/component';

/**
 * Expands/collapses the line-clamped SEO description on collection pages.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} description
 * @property {HTMLButtonElement} toggleButton
 * @property {HTMLElement} toggleLabel
 *
 * @extends {Component<Refs>}
 */
export class CollectionTextSeoComponent extends Component {
  requiredRefs = ['description', 'toggleButton', 'toggleLabel'];

  toggleExpanded() {
    const expanded = this.classList.toggle('collection-text-seo--expanded');

    this.refs.toggleLabel.textContent = expanded ? 'Ver menos' : 'Ver mais';
    this.refs.toggleButton.setAttribute('aria-expanded', String(expanded));
  }
}

if (!customElements.get('collection-text-seo-component')) {
  customElements.define('collection-text-seo-component', CollectionTextSeoComponent);
}
